import { useSyncExternalStore } from "react";
import { APP_CONSTANTS } from "@/config";
import { useAuth } from "@/hooks/use-auth";

const subscribe = (refresh: () => void) => {
  window.addEventListener("storage", refresh);
  return () => window.removeEventListener("storage", refresh);
};
const readTenant = () => localStorage.getItem(APP_CONSTANTS.COMPANY_LOCAL_STORAGE_KEY);

export function useNotificationIdentity() {
  const { user } = useAuth();
  const selectedTenant = useSyncExternalStore(subscribe, readTenant, () => null);
  return { tenantId: user?.tenant_id || selectedTenant || null, userId: user?.id ?? null };
}
